<template>
    <div>
        <flash-error ref="flashError"></flash-error>
        <progress-bar percentages="65"></progress-bar>
        <section id="service-section" class="py-2 mobile-container">
            <div class="d-flex align-items-center justify-content-between text-light">
                <div>Fuldmagt</div>
                <div>
                    <div class="info-box d-flex align-items-center justify-content-center cursor-pointer"
                         @click="openModalIframe">
                        <span class="material-symbols-outlined" style="font-size: 20px;">info_i</span>
                    </div>
                </div>
            </div>
        </section>
        <section id="text-section" class="mobile-container bg-light">
            <div class="py-2">
                <div class="mb-4">
                    <div class="mb-3">Ønsker du at give fuldmagt til, at dine varer må stilles på din adresse?</div>
                    <div>
                        Obs. såfremt chaufføren vurderer, at det ikke er muligt at stille varerne det valgte sted -
                        tages de med retur til terminalen.
                    </div>
                </div>
                <div class="mb-4">
                    <div class="d-flex mb-1">
                        <input type="checkbox"
                               id="no"
                               @change="onChange('no')"
                               v-model="no">
                        <label class="ml-2 mb-0" for="no">Nej.</label>
                    </div>
                    <div>Jeg vil gerne være hjemme til at tage imod min levering.</div>
                </div>
                <div class="mb-4">
                    <div class="d-flex mb-1">
                        <input type="checkbox"
                               id="yes"
                               @change="onChange('yes')"
                               v-model="yes">
                        <label class="ml-2 mb-0" for="yes">Ja.</label>
                    </div>
                    <div>Leveringen må stilles</div>
                </div>
                <div class="mb-4" v-if="yes">
                    <div class="align-items-center bg-white border rounded-lg div-focus">
                        <v-select
                            :options="permits"
                            v-model="additionalServices.permits.value"
                        >
                        </v-select>
                    </div>
                </div>
                <div>
                    <button class="btn btn-success"
                            :disabled="(!yes && !no) || (yes && !additionalServices.permits.value.length)"
                            @click="goNext"
                    >Næste STEP</button>
                </div>
            </div>
        </section>
        <back-section :url="prevUrl" type="1"></back-section>

        <modal-iframe ref="modal-iframe"
                      @toggleActiveIframeModalInterval="toggleActiveIframeModalInterval"
        ></modal-iframe>
        <div v-if="activeIframeModalInterval" class="modal-backdrop fade show"></div>

    </div>

</template>

<script>
import ProgressBar from "./reusable/ProgressBar.vue";
import BackSection from "./reusable/BackSection.vue";
import ModalIframe from "./reusable/ModalIframe.vue";
import FlashError from "./reusable/FlashError.vue";
import 'vue-select/dist/vue-select.css';
export default {
    name: "CmfStep4",
    components: {ModalIframe, ProgressBar, BackSection, FlashError},
    props: {
        configurations: {type: Object, required: true},
        nextUrl: {type: String, required: true},
        prevUrl: {type: String, required: true},
        applyChangesUrl: {type: String, required: true},
        permitsKey: {type: String, required: true},
        additionalServicesProp: {type: Object|Array, required: true}
    },
    data() {
        return {
            activeIframeModalInterval: false,
            no: this.additionalServicesProp[this.permitsKey] ? !this.additionalServicesProp[this.permitsKey]['enabled'] : false,
            yes: this.additionalServicesProp[this.permitsKey] ? this.additionalServicesProp[this.permitsKey]['enabled'] : false,
            permits: this.configurations['permits'] ? JSON.parse(this.configurations.permits.value) : [],
            additionalServices: {
                permits: this.additionalServicesProp[this.permitsKey] ?
                    this.additionalServicesProp[this.permitsKey] :
                    {
                        key: this.permitsKey,
                        name: 'Leveringen må stilles',
                        value: [],
                        price: 0,
                        enabled: false
                    },
            },
        }
    },
    methods: {
        onChange(type) {
            this.additionalServices.permits.enabled = false;
            if (type === 'no' && this.no) {
                this.yes = false;
            } else if(type === 'yes' && this.yes) {
                this.additionalServices.permits.enabled = true;
                this.no = false;
            }
        },
        goNext() {
            if ((this.yes && this.additionalServices.permits.value.length) || this.no) {
                axios.post(this.applyChangesUrl, this.additionalServices)
                    .then((response) => {
                        window.location.href = this.nextUrl;

                    }).catch(error => {
                    this.$refs.flashError.flashError(error);
                });
            }
        },
        openModalIframe() {
            this.$refs["modal-iframe"].toggleModal();
        },
        toggleActiveIframeModalInterval() {
            this.activeIframeModalInterval = !this.activeIframeModalInterval;
        },

    },
}

</script>

<style scoped>

</style>
